import React, { useEffect, useState } from "react";
import { Route, Routes, Navigate, Link, useNavigate } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Settings from "./pages/Settings2";
import pb from "lib/pocketbase";
import { UserContext } from "lib/UserContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Test from "./pages/Test";
import toast, { Toaster } from "react-hot-toast";
import Debugger from "components/Debugger";
import { zdConfig } from "./zdConfig";

import useDocumentTitle from "components/useDocumentTitle";

export default function App() {
  const [user, setUser] = useState(null);
  const [showDebugger, setShowDebugger] = useState(false);
  const navigate = useNavigate();

  useDocumentTitle(
    user
      ? `(${user.public_comments_today}) Zendash ${zdConfig.version}`
      : `Zendash  ${zdConfig.version}`
  );

  return (
    <UserContext.Provider value={{ user, setUser }}>
      <Toaster />
      <Navbar />
      <main className="container-fluid d-flex justify-content-center p-4">
        <Routes>
          <Route
            path="/"
            element={
              user ? <Navigate to="/dashboard" /> : <Navigate to="/login" />
            }
          ></Route>{" "}
          <Route
            path="/login"
            element={user ? <Navigate to="/dashboard" /> : <Login />}
          ></Route>{" "}
          <Route
            path="/dashboard"
            element={user ? <Dashboard /> : <Navigate to="/" />}
          ></Route>{" "}
          <Route
            path="/settings"
            element={user ? <Settings /> : <Navigate to="/" />}
          ></Route>{" "}
          <Route path="/*" element={<Navigate to="/" />}></Route>{" "}
          {/* <Route path="/test" element={<Test />}></Route>{" "} */}
        </Routes>
      </main>{" "}
      {user && user.username === "scott" && (
        <div>
          <button
            className="btn btn-outline-dark"
            onClick={() => setShowDebugger(!showDebugger)}
          >
            {showDebugger ? "Hide" : "Show"} Debugger
          </button>
          {showDebugger && <Debugger />}
        </div>
      )}
    </UserContext.Provider>
  );
}
